module.exports = __webpack_public_path__ + "img/address.0f0b0af4.png";